$(document).ready(function () {
  // Initialize Slick slider
  if($('.frequently-bought-slider.slick-initialized').length){
    
  }else{
    $(".frequently-bought-slider").slick({
      dots: false,
      arrows: true,
      prevArrow: $(".custom-prev-arrow"),
      nextArrow: $(".custom-next-arrow"),
      slidesToShow: 2, // Number of slides to show at a time
      slidesToScroll: 1, // Number of slides to scroll
      responsive: [
        {
          breakpoint: 992, // Breakpoint for smaller screens (tablet)
          settings: {
            rows: 1,
            centerMode: true,
            slidesToScroll: 1,
            slidesToShow: 2, // Adjust number of slides to show for tablets
          },
        },
        {
          breakpoint: 576, // Breakpoint for smaller screens (mobile)
          settings: {
            rows: 1,
            centerMode: true,
            slidesToScroll: 1,
            slidesToShow: 2, // Adjust number of slides to show for mobile
          },
        },
      ],
    });
  }
});
